<!-- 销售退补价申请 -->
<template>
   <div class='page_content'>
      <processAuditAction ref="processAuditAction"></processAuditAction>
      <subComponents ref="showSelectData"></subComponents>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
         <div class="page_content_top_line">
            <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch"></v-search>
            <el-tag class="tag" type="danger">总金额:￥{{ totalMoney }}</el-tag>
         </div>
      </div>
      <div class="page_content_center">
         <el-table size="mini" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row
                   @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="40">
            </el-table-column>
            <el-table-column align="center" v-if="tableValye.isShow==1" v-for="(tableValye,tableKey) in pageShowData.jurTableVo.jurconfigtable" show-overflow-tooltip :min-width="tableValye.fieldWeight" :key="tableKey"
                             :prop="tableValye.entityField" :label="tableValye.showField">
               <template slot-scope="scope">
                  <span v-if="tableValye.fieldType == 'date'">
                     <span v-if="scope.row[tableValye.entityField]">
                        {{$common.getLocalTime(scope.row[tableValye.entityField])}}
                     </span>
                  </span>
                  <span v-else-if="tableValye.isRift == 1">
                     <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
                  </span>
                  <el-tag v-else-if="tableValye.entityField == 'rramState'" size="mini" type="primary">
                     {{$common.getIsGsp(tableValye.formatterContent,scope.row.rramState)}}</el-tag>
                  <span v-else-if="tableValye.entityField == 'createTime'">
                     <span v-if="scope.row[tableValye.entityField]">
                        {{$common.getLocalTime(scope.row[tableValye.entityField])}}
                     </span>
                  </span>
                  <span v-else>
                     {{scope.row[tableValye.entityField]}}
                  </span>
               </template>
            </el-table-column>
         </el-table>
      </div>
      <div class="page_content_bottom">
         <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" :smId="smId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <!-- 自定义设计 -->
      <customDesign ref="customDesign"></customDesign>

   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
export default {
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
   },
   data() {
      //这里存放数据
      return {
         tableHeight: 0,
         getRequestData: {
            rramRetcus: "",
            cmName: "",
            page: 1,
            rows: 30,
            start:
               new Date(new Date().toLocaleDateString()).getTime() -
               31 * 24 * 3600 * 1000, //开始上一个月
            end:
               new Date(new Date().toLocaleDateString()).getTime() +
               24 * 60 * 60 * 1000 -
               1, //当天最后时间
         },
         returnData: {
            pages: 0, // 总页数
            total: 0, // 总条数
            pageNum: 0, // 当前页数
            list: [],
         },
         buttonList: [],
         pageShowData: [],
         selectedDataIndex: 0,
         exId: "",
         seId: "",
         ceshi: "",
         dialogTitle: "",
         seWidth: "",
         height: "",
         exTitle: "",
         seTitle: "",
         seWidth: "",
         exWidth: "",
         DialogVisible: false,
         DialogExtract: false,
         seType: "",
         smId: "",
         parentSearchData: {},
         sField: "",
         selectVal: [],
         totalMoney: 0,
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "getRequestData.cmName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               this.getRequestData.rramRetcus = "";
            }
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      handleSelectionChange(val) {
         this.selectVal = val
      },
      getIsGsp(str, val) {
         try {
            str && str.replace(/\\/g, "");
            let arr = JSON.parse(str);
            let len = arr.length;
            let newStr = "";
            for (let i = 0; i < len; i++) {
               if (arr[i].key == val) {
                  newStr = arr[i].value;
                  break;
               }
            }
            return newStr;
         } catch (ex) {
            return str;
         }
      },
      // 子组件触发
      drawerCancel() {
         this.showStatus = false;
         this.getDataList();
      },
      // 点击穿透字段 传参单号
      toDetail(orderId) {
         if (orderId) {
            // 设置为true 打开穿透组件首页
            var isPenetrate = true;
            // 设置缓存 存入点击单号
            this.resetSetItem("penetrateOrderId", orderId);
            // 与父级跨域通信 传递isPenetrate参数
            window.parent.postMessage(
               {
                  //向窗口发送MessageEvent消息
                  cmd: "returnFormJson",
                  params: { isPenetrate }, //参数
               },
               "*"
            );
         }
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      getExtractName(e) {
         this.exTitle = e;
      },
      // 检索Id, 索引(表格中), 标识
      openSearch({ sId, index, type, sField }) {
         this.DialogVisible = true;
         this.seId = sId;
         this.sField = sField;
         this.parentSearchData[type] = this.getRequestData[type];
      },
      //检索带回数据
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val);
         }
      },
      // 赋值字段
      paramValue(val) {
         console.log(this.sField);
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.getRequestData[item] = val[item];
         });
      },
      isShowData(name, value) {
         switch (name) {
            case "customerList":
               var dataInfo = sessionStorage.getItem("selectCustomerData");
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo);
                  this.getRequestData.rramRetcus = dataInfo.cmId;
                  this.getRequestData.cmName = dataInfo.cmName;
               }

               break;

            default:
               this.getRequestData[name] = value;
         }
      },

      // 获取数据列表
      async getPageInfo() {
         var pathId = parent.getMenuInfo(this.$route.path);
         let responseData = await this.$http.getJur({ ids: [pathId.jurId] });
         if (responseData.status == 200) {
            console.log(responseData.result);
            this.pageShowData = responseData.result;
            var obj = {}
            if (this.pageShowData.jurHead) {
               obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30, false)
            } else {
               obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30, false)
            }
            for (const key in obj) {
               this.$set(this.getRequestData, key, obj[key])
            }
            this.getDataList();
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },

      // 动作集合
      actionSet(actionData) {
         if (actionData.actionType != 15) {
            if (this.returnData.list.length <= 0) {
               if (!dataInfo) {
                  this.$message({
                     message: "暂无数据",
                     type: "error",
                  });
                  return false;
               }
            }
            if (this.selectVal.length == 0) {
               this.$message({
                  message: "请先选择您要操作的数据",
                  type: "error",
               });
               return false;
            }
            var dataInfo = JSON.parse(
               JSON.stringify(this.returnData.list[this.selectedDataIndex])
            );
         }


         switch (actionData.actionType) {
            case 4:
               var arr = []
               this.selectVal.forEach(item => {
                  arr.push(item.rramId)
               })
               this.$refs["processAuditAction"].openBox(0, arr);
               // this.$refs["processAuditAction"].openBox(0, dataInfo.rramId);
               break;
            case 5:
               if (this.selectVal.length > 1) {
                  this.$message({
                     message: "请勾选一条数据",
                     type: "error",
                  });
                  return false;
               }
               this.$refs["processAuditAction"].openBox(1, this.selectVal[0].rramId);
               // this.$refs["processAuditAction"].openBox(1, dataInfo.rramId);
               break;
         }
      },

      openFormDesign() {
         let pathInfo = parent.getMenuInfo(this.$route.path)
         this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
      },
      // 数据搜索
      searchData() {
         this.getRequestData.page = 1;
         this.getDataList();
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val;
         this.getDataList();
      },
      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1;
         this.getRequestData.rows = val;
         this.getDataList();
      },
      // 获取数据列表
      async getDataList() {
         if (this.getRequestData.cmName == "") {
            this.getRequestData.cmId = "";
         }
         let responseData = await this.$http.getSalesReimbursementTask(
            this.getRequestData
         );
         this.totalMoney=0
         if (responseData.status == 200) {
            this.returnData.list = responseData.result.list;
            this.returnData.pages = responseData.result.pages;
            this.returnData.total = responseData.result.total;
            this.returnData.pageNum = responseData.result.pageNum;
            this.selectedDataIndex = 0;
            this.getMoney(this.getRequestData)
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      async getMoney(val) {
         let responseData = await this.$http.RrApplyquerySumMoney(val)
         console.log(responseData,"测试");
         
         if (responseData.status == 200) {
            this.totalMoney=responseData.result||0
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 获取按钮权限
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton()
         
      },
},
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getPageInfo();
      this.getDataList();
      this.getButtonList();
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
   margin-right: 1rem;
}

.el-tabs--border-card_new {
   height: 85vh;
   overflow-y: scroll;
}
.page_content_top_line{
  justify-content: space-between;
  
}
.tag{
  font-size: 18px;
}
</style>